import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpStatusCode,
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorRedirectInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const resultNotFound =
      httpRequest.url.match('/api/ancestry/results') ||
      httpRequest.url.match('/api/prs/analyses') ||
      httpRequest.url.match('/api/dna/analyses') ||
      httpRequest.url.match('/api/dna/reports') ||
      httpRequest.url.match('/api/prs/reports');

    const isProductUrl =
      this.router.url.match('/prs/results') ||
      this.router.url.match('/prs/dna') ||
      this.router.url.match('/prs/analyses') ||
      this.router.url.match('/dna/analyses') ||
      this.router.url.match('/dna/results') ||
      this.router.url.match('/ancestry');

    return next.handle(httpRequest).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (
            error.status === HttpStatusCode.NotFound &&
            resultNotFound &&
            isProductUrl
          ) {
            this.router.navigate(['/products/premium-pack'], {
              replaceUrl: true,
            });
            return EMPTY;
          }
        }
        return throwError(error);
      })
    );
  }
}
